import ImageUrlBuilder from "@sanity/image-url";
import { client } from "../../../../client";
import style from "./FullWidthTextWithPicture.module.css";

export const FullWidthTextWithPicture = (props) => {
    const imageBuilder = ImageUrlBuilder(client);

    return (
        <div className={style.moduleWrapper}>
            <div className={style.textWrapper}>
                <h2>{props.content.textContent}</h2>
            </div>
            <div
                className={style.imageWrapper}
                style={{
                    background: `url(${imageBuilder.image(props.content.image)}) no-repeat`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            ></div>
        </div>
    );
};
